import { useMutation } from '@tanstack/react-query';

import { profileTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const removeProfilePage: profileTypes.RemoveProfilePage = (params) => {
  return axios.delete(`/profile/page`, { params });
};

type UseRemoveProfilePageOptions = {
  config?: MutationConfig<typeof removeProfilePage>;
};

export function useRemoveProfilePage({ config = {} }: UseRemoveProfilePageOptions = {}) {
  return useMutation({
    ...config,
    onSuccess: (...params) => {
      queryClient.invalidateQueries(['profiles']);
      config.onSuccess && config.onSuccess(...params);
    },
    mutationFn: removeProfilePage,
  });
}
